import { isEqual } from 'es-toolkit';
import type { FilterBound } from '../types';

const toggleValue =
  <T>(value: T) =>
  (prev: T[] = []) =>
    prev.some((v) => isEqual(v, value))
      ? prev.filter((v) => !isEqual(v, value))
      : [...prev, value];

export function arrayFilterMethods<T>({
  appliedValue = [],
  selectedValue = [],
  setSelected,
  setApplied
}: FilterBound<T[]>) {
  const toggleSelectedValue = (value: T) => setSelected(toggleValue(value));
  const toggleAppliedValue = (value: T) => setApplied(toggleValue(value));

  return {
    hasSelectedValue: (value: T) =>
      selectedValue.some((v) => isEqual(v, value)),
    toggleSelectedValue,
    resetSelectedValues: () => setSelected(() => []),
    hasAppliedValue: (value: T) => appliedValue.some((v) => isEqual(v, value)),
    toggleAppliedValue: (value: T) => {
      toggleSelectedValue(value);
      toggleAppliedValue(value);
    },
    resetAppliedValues: () => setApplied(() => []),
    isSelected: selectedValue.length > 0,
    isApplied: appliedValue.length > 0,
    appliedSize: appliedValue.length
  };
}
